import { DateTime } from 'luxon';
import * as EntityType from '../../types/entities';

export type PurchasesState = {
    search: string;
    region: EntityType.Region[];
    okpd2: EntityType.Okpd2[];
    section: EntityType.Section[];
    tariff: EntityType.Tariff[];
    block: EntityType.Block[];
    procedureTemplate: EntityType.ProcedureTemplate[];
    publishedFrom: DateTime | null;
    publishedTo: DateTime | null;
    receiveStartFrom: DateTime | null;
    receiveStartTo: DateTime | null;
    receiveFinishFrom: DateTime | null;
    receiveFinishTo: DateTime | null;
    startPriceFrom: number | null;
    startPriceTo: number | null;
    procedure: EntityType.Procedure[];
    freeParticipation: boolean;
    sectionOrg: number | null;
    sortBy: string;
    sortOrder: number;
    page: number;
};

export const initialEmptyState: PurchasesState = {
    search: '',
    region: [],
    okpd2: [],
    section: [],
    tariff: [],
    block: [],
    procedureTemplate: [],
    publishedFrom: null,
    publishedTo: null,
    receiveStartFrom: null,
    receiveStartTo: null,
    receiveFinishFrom: null,
    receiveFinishTo: null,
    startPriceFrom: null,
    startPriceTo: null,
    procedure: [],
    freeParticipation: false,
    sectionOrg: null,
    sortBy: 'publish_date',
    sortOrder: -1,
    page: 1,
};
